export default "__VITE_ASSET__76fad6df__$_?component__"